<div class="carousel-network-projects">
  <app-carousel [items]="data">
    <ng-template let-slide>
      <a class="carousel-network-projects__post" [href]="slide.link" target="_blank">
        <img class="carousel-network-projects__image" loading="lazy" [src]="slide.image" [alt]="slide.titulo" />
        <div class="carousel-network-projects__info">
          <p>{{ slide.title }}</p>
          <span>{{ slide.description }}</span>
        </div>
      </a>
    </ng-template>
  </app-carousel>
</div>
